import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';

export const REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL =
  'periscopeDashboardIframe/REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL';
export const requestPeriscopeDashboardIframe = () => ({
  type: REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL,
});

export const GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED =
  'periscopeDashboardIframe/GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED';
export const getPeriscopeDashboardIFrameUrlFailed = ({ error }) => ({
  type: GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED,
  error: true,
  payload: error,
});

export const GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED =
  'periscopeDashboardIframe/GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED';
export const getPeriscopeDashboardIFrameUrlSucceeded = ({ url }) => ({
  type: GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED,
  payload: {
    url,
  },
});

export const PERISCOPE_DATA_SUCCESS =
  'periscopeDashboardIframe/PERISCOPE_DATA_SUCCESS';
export const periscopeDataRequestSuccess = () => ({
  type: PERISCOPE_DATA_SUCCESS,
});

export const PERISCOPE_DATA_FAILURE =
  'periscopeDashboardIframe/PERISCOPE_DATA_FAILURE';
export const periscopeDataRequestFailure = () => ({
  type: PERISCOPE_DATA_FAILURE,
});

export const CLEAR_PERISCOPE_STATE =
  'periscopeDashboardIframe/CLEAR_PERISCOPE_STATE';
export const clearPeriscopeState = () => ({
  type: CLEAR_PERISCOPE_STATE,
});

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'reporting/ALERT_BAR_ACTION';
export const reportingAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

const INITIAL_STATE = {
  url: '',
  dashboardUrlRequestPending: false,
  dasboardUrlRequestError: '',
  periscopeDataPending: false,
  periscopeDataSuccess: false,
  periscopeDataFailure: false,
};

export const _reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL:
      return {
        ...state,
        dashboardUrlRequestPending: true,
        periscopeDataPending: true,
        periscopeDataSuccess: false,
        periscopeDataFailure: false,
      };
    case GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED:
      return {
        ...state,
        dashboardUrlRequestPending: false,
        dashboardUrlRequestError: '',
        url: payload.url,
      };
    case GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED:
      return {
        ...state,
        dashboardUrlRequestPending: false,
        dashboardUrlRequestError: payload,
      };
    case PERISCOPE_DATA_SUCCESS:
      return {
        ...state,
        periscopeDataPending: false,
        periscopeDataSuccess: true,
      };
    case PERISCOPE_DATA_FAILURE:
      return {
        ...state,
        periscopeDataPending: false,
        periscopeDataFailure: true,
      };
    case CLEAR_PERISCOPE_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.reporting,
});

export const _mapDispatchToProps = () => {};

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      reportingAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
  },
  'reporting',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
